import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss']
})
export class ServiceComponent implements OnInit {

  box;
  boxtable;
  enter;
  entertoaddBox;
  forcetoaddBox;

  constructor() { }

  ngOnInit() {
  }

}
